import ReactGA4 from 'react-ga4';

const isProduction = import.meta.env.MODE === 'production';

const InitializeGoogleAnalytics = () => {
  if (!isProduction || !import.meta.env.VITE_ANALYTICS_ID) {
    return;
  }
  ReactGA4.initialize(import.meta.env.VITE_ANALYTICS_ID);

  console.log('GA INITIALIZED');
};

interface TrackGoogleAnalyticsEventProps {
  category: string;
  eventName: string;
  action: string;
  data?: Record;
}

const TrackGoogleAnalyticsEvent = ({
  category,
  eventName,
  data = {}
}: TrackGoogleAnalyticsEventProps) => {
  if (!isProduction) {
    return;
  }

  console.log('GA event:', category, ':', eventName, ':');

  const eventParams = {
    category,
    ...data
  };
  // Send GA4 Event
  ReactGA4.event(eventName, eventParams);
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
